import { Button, Col, Container, Jumbotron, Modal, Row } from "react-bootstrap"
import { BsPlusCircleFill } from "react-icons/bs"
import { Link, useParams } from "react-router-dom"
import ReactPaginate from "react-paginate"
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri"
import { useContext, useEffect, useState } from "react"
import Get from "../../api/Get"
import { APPOINTMENT_CANCEL, MY_APPOINTMENT, PACIENTE_BY_EMAIL, PACIENTE_BY_ID } from "../../api/Routes"
import { authContext } from "../../context/AuthContext"
import LoadingList from "../../loader/LoadingList"
import { isCitasProximas } from "../../utils/isCitasProximas"
import CardCitas from "../../components/CardCitas"
import Post from "../../api/Post"
import SimpleLoad from "../../loader/SimpleLoad"
import moment from "moment"
import { withTranslation } from "react-i18next"
import ComponentModalErrorSever from "../../components/ComponentModalErrorSever"


function MisCitas({t, imPaciente}){
    const {id} = useParams()
    const {auth} = useContext(authContext)
    const [paciente, setPaciente] = useState(null)
    const [proximasCitas, setProximasCitas] = useState([])
    const [previasCitas, setPreviasCitas] = useState([])    
    const [loading, setLoading]= useState(true)
    
    //pagin previud scitas
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(0)
    const postsPerPage = 10;
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;

    //pagin next citas
    const [currentPageNext, setCurrentPageNext] = useState(1);
    const [pageCountNext, setPageCountNext] = useState(0)
    const postsPerPageNext = 6;
    const indexOfLastPostNext = currentPageNext * postsPerPageNext;
    const indexOfFirstPostNext = indexOfLastPostNext - postsPerPageNext;

    //sever
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleCloseServer = () => setShowModalError(false)

    //id paciente
    const [idPatient, setIdPatient] = useState(null)

    //efecto para busar el paciente
    useEffect(()=>{
        if(id===undefined || id ===null){
            Get({url: `${PACIENTE_BY_EMAIL}/${auth.data.username}`, access_token: auth.data.access_token})
            .then(respo=>{
                setPaciente(respo.data)
                setIdPatient(respo.data.id)
            })
            .catch(error=>{
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
            })
        }else{
            setIdPatient(id)
            Get({url: `${PACIENTE_BY_ID}/${id}`, access_token: auth.data.access_token})
            .then(respo=>{
                setPaciente(respo.data)
            })
            .catch(error=>{
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
            })
        }
    }, [])

    useEffect(()=>{
        if(idPatient){
            Get({url: `${MY_APPOINTMENT}/${idPatient}`, access_token: auth.data.access_token})
            .then(response=>{ 

                let proximas = response.data.data.response.filter(item=>isCitasProximas(item.scheduleDTO.dateTimeInit))
                let previas = response.data.data.response.filter(item=>!isCitasProximas(item.scheduleDTO.dateTimeInit))
                                    
                setProximasCitas(proximas.reverse())
                setPreviasCitas(previas)
                        
                if(previas.length > 0){
                    let pC = Math.ceil(previas.length / postsPerPage)
                    setPageCount(pC)
                } 
                if(proximas.length > 0){
                    let pC = Math.ceil(proximas.length / postsPerPageNext)                        
                    setPageCountNext(pC)
                }          
                setLoading(false)    
            })
        }
    },[idPatient])

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected+1)
    }
    const handlePageClickNext = (data) =>{
        setCurrentPageNext(data.selected+1)
    }

    const [loadingDelete, setLoadingDelete] = useState(false)
    const [showModelCancel, setShowModalCancel] = useState(false)
    const [objDelete, setObjDelete] = useState(null)
    const deleteCita = id =>{
        //console.log(id)
        setLoadingDelete(true)
        let d = {
            id: id,
            appointmentStatus: "Pagada"
        }
        Post({url: APPOINTMENT_CANCEL, data: d, header: true, access_token: auth.data.access_token})
        .then(response=>{
           // console.log(response)
            let arr = [...proximasCitas]
            let index = arr.findIndex(e=>e.id===id)
            arr[index].appointmentStatus = "Cancelada"
            setProximasCitas(arr)
            setLoadingDelete(false)
            setShowModalCancel(false)
        })
        .catch(error=>{
            //console.log('error')
            //console.log(error)
            setLoadingDelete(false)
        })
    }

    const handleClose = () => setShowModalCancel(false)
    return(
        <>
            {loading && <LoadingList />}
            <Row className="align-items-center">
                <Col xs="12" md="8">
                    <h2 className="mb-0 title-top-2">{!imPaciente ? 'Citas del paciente' : t('mis_citas')}</h2>
                    {paciente && <label className="font-weight-bold text-secondary">{`${paciente.name} ${paciente.middleName ?? ''} ${paciente.lastName} ${paciente.seccondSurname ?? ''}`}</label>}
                </Col>
                <Col xs="12" md="4">
                    <Row className="align-items-center">
                        <Col xs="12" md="12" className="text-right">
                            <Link to={(id===undefined || id===null) ? `/admin` : `/admin/create-appointment/${id}`}><BsPlusCircleFill className="add-btn"/></Link>                        
                        </Col>
                    </Row>                
                </Col>
            </Row>
            <Row>
                {!loading && <Col xs="12" md="12"><h2 className="color-646D82">{t('proximas')}</h2></Col>}

                <Col xs="12" md="12">
                    {
                        (proximasCitas.length === 0 && !loading) &&
                        <Row className="mt-5">
                            <Col>
                                <Jumbotron>
                                    <Container>
                                        <p className="text-center">{t('no_hay_citas')}</p>
                                    </Container>
                                </Jumbotron>
                            </Col>
                        </Row>
                    }
                    <Row>
                    {
                        proximasCitas.slice(indexOfFirstPostNext, indexOfLastPostNext).map((item, i)=>(
                            <Col xs="12" md="4" key={i}>
                                <CardCitas item={item} 
                                    trash={true} 
                                    imPaciente={imPaciente} 
                                    auth={auth} 
                                    deleteCita={deleteCita}
                                    loadingDelete={loadingDelete}
                                    showModelCancel={showModelCancel}
                                    setShowModalCancel={setShowModalCancel}
                                    objDelete={objDelete}
                                    setObjDelete={setObjDelete}

                                />
                            </Col>
                        ))
                    }
                    </Row>
                    {proximasCitas.length > 0 && 
                        <Row className="mt-5">
                            <Col>
                                <ReactPaginate
                                    previousLabel={<RiArrowLeftSLine />}
                                    nextLabel={<RiArrowRightSLine />}
                                    breakLabel={'...'}
                                    breakClassName={'break-me'}
                                    pageCount={pageCountNext}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={3}
                                    onPageChange={handlePageClickNext}
                                    containerClassName={'pagination'}
                                    subContainerClassName={'pages pagination'}
                                    activeClassName={'active'}
                                />
                            </Col>
                        </Row>
                    }
                    
                </Col>
            </Row>

            <Row className="mt-4">
                {!loading && <Col xs="12" md="12"><h2 className="color-646D82">{t('anteriores')}</h2></Col>}

                <Col xs="12" md="12">
                    {
                        (previasCitas.length === 0 && !loading) &&
                        <Row className="mt-5">
                            <Col>
                                <Jumbotron>
                                    <Container>
                                        <p className="text-center">{t('no_hay_citas')}</p>
                                    </Container>
                                </Jumbotron>
                            </Col>
                        </Row>
                    }

                    <Row>
                        {
                            previasCitas.slice(indexOfFirstPost, indexOfLastPost).map((item, i)=>(
                                <Col xs="12" md="4" key={i}>
                                    <CardCitas item={item} trash={false} imPaciente={imPaciente} auth={auth}/>
                                </Col>
                            ))
                        }
                    </Row>
                    {previasCitas.length > 0 && 
                        <Row className="mt-5">
                            <Col>
                                <ReactPaginate
                                    previousLabel={<RiArrowLeftSLine />}
                                    nextLabel={<RiArrowRightSLine />}
                                    breakLabel={'...'}
                                    breakClassName={'break-me'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={3}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination'}
                                    subContainerClassName={'pages pagination'}
                                    activeClassName={'active'}
                                />
                            </Col>
                        </Row>
                    }
                </Col>
            </Row>
            <Modal show={showModelCancel} onHide={handleClose} centered className="border-0" backdrop="static" keyboard={false}>
                <Modal.Body>
                    <div className="position-relative"> 
                        {loadingDelete && <SimpleLoad />}                       
                        <h5 className="text-red font-weight-bold">{t('estas_seguro')}</h5>
                        <label className="color-6A6A font-size-09rem">{t('text_confirm_elimnar_cita')}:</label>

                        <div className="font-size-09rem color-6A6A">
                            <label><strong className="text-dark">{t('nombre_completo')}: </strong>{objDelete && `${objDelete.patientDTO.name} ${objDelete.patientDTO?.middleName ?? ''} ${objDelete.patientDTO.lastName} ${objDelete.patientDTO?.seccondSurname ?? ''}`}</label>
                        </div>
                        <div className="font-size-09rem color-6A6A">
                            <label><strong className="text-dark">{t('Correoelectronico')}: </strong>{objDelete && objDelete.patientDTO.email }</label>
                        </div>
                        <div className="font-size-09rem color-6A6A">
                            <label><strong className="text-dark">{t('Telefono')}: </strong>{objDelete && objDelete.patientDTO.phone }</label>
                        </div>

                        <div className="my-2">
                            <strong className="title-top-2">{t('horario')}</strong>
                        </div>
                        <div className="font-size-09rem color-6A6A">
                            <label><strong className="text-dark">{t('fecha')}: </strong>{objDelete &&   `${moment(objDelete.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("dddd DD MMMM YYYY HH:mm")} hrs`}</label>
                        </div>
                        <div className="font-size-09rem color-6A6A">
                            <label><strong className="text-dark">{t('doctor')}: </strong>{objDelete && `${objDelete.scheduleDTO.doctor.name} ${objDelete.scheduleDTO.doctor.lastName}` }</label>
                        </div>
                        <div className="font-size-09rem color-6A6A">
                            <label><strong className="text-dark">{t('especialidad')}: </strong>{objDelete && objDelete.scheduleDTO.doctor.espcialityList[0].name }</label>
                        </div>

                        <div className="text-right mt-4">
                            <Button className="cancel-button px-4" variant="danger" type="button" onClick={e=>deleteCita(objDelete && objDelete.id)}>{t('eliminar')}</Button>
                            <Button variant="link" className="text-secondary no-underline" type="button" onClick={e=>setShowModalCancel(false)}>{t('regresar')}</Button>
                        </div>                        
                    </div>                
                </Modal.Body>
            </Modal>
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleCloseServer}
                error={errorServer}
            />
        </>
    )
}

export default withTranslation()(MisCitas)